module.exports = __webpack_public_path__ + "static/media/ailsa-bay-featured.3fe9b0f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/featured-imgs/ailsa-bay-featured.jpg
// module id = 470
// module chunks = 0